import { useState, useCallback } from 'react'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import TextArea from '../../../../../../../../forms/Input/TextArea'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'

interface ModalEditTurnNotesProps extends ModalEditTurnNotesLogicProps { }

const ModalEditTurnNotes: React.FC<ModalEditTurnNotesProps> = ({ setOpenModal, ...rest }) => {
    const { notesValue, setNotesValue, editTurnNotes } = useModalEditTurnNotesLogic({ setOpenModal, ...rest })
    const { t } = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={() => setOpenModal(null)} className='big_small_centered'>
            <div>
                <h2><TwinTrans transKey='editNote'>Editar nota</TwinTrans></h2>
                <TextArea className='mt-15' label={''} placeholder={t('write', 'Escribe...')} onChange={setNotesValue} value={notesValue} />
            </div>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={() => setOpenModal(null)} onAccept={editTurnNotes} />
        </ModalSmallCentered>
    )
}

interface ModalEditTurnNotesLogicProps {
    allRowData: RowData
    setOpenModal: SetEditDeleteModalTy
    getData: () => Promise<void>
}

const useModalEditTurnNotesLogic = ({ setOpenModal, allRowData, getData }: ModalEditTurnNotesLogicProps) => {
    const [notesValue, setNotesValue] = useState<string>(allRowData?.turn?.notes || '')

     const editTurnNotes = useCallback(async () => {
            const result = await twinFetchPostJSON('/api/app/workingCalendar/workingCalendarTurn/updateWCalTurn', {
                id: allRowData?.turn?.TurnId,
                notes: notesValue
            })
            if (result) {
                setOpenModal(null)
                getData()
            }
     }, [setOpenModal, allRowData, notesValue, getData])
    return { editTurnNotes, setNotesValue, notesValue }
}

export default ModalEditTurnNotes